<template>
  <div v-if="companyKey === 'BSG'">
    <router-link
        v-if="operationType === 'go_work_mobile'"
        :to="{ name: 'privateCoachingGoWorkMobileFirstInterviewForm', params: { id } }"
        class="btn btn-primary">
      Bericht
    </router-link>

    <router-link
        v-else-if="operationType === 'modular_integration_coaching'"
        :to="{ name: 'privateCoachingMicFirstInterviewV2Form', params: { id } }"
        class="btn btn-primary">
      Bericht
    </router-link>

    <router-link
        v-else
        :to="{ name: 'privateCoachingFirstInterviewForm', params: { id } }"
        class="btn btn-primary">
      Bericht
    </router-link>
  </div>

  <div v-if="companyKey === 'BBQ' || companyKey === 'WAR'">
    <router-link
        :to="{ name: 'bbqPrivateCoachingMicFirstInterviewV2Form', params: { id } }"
        class="btn btn-primary">
      Bericht
    </router-link>
  </div>
</template>

<script setup>
import {defineProps} from 'vue';

defineProps({
  companyKey: {
    type: String,
    required: true
  },
  operationType: {
    type: String,
    default: null
  },
  id: {
    type: [Number, String],
    required: true
  }
})
</script>